// src/Components/Tournaments/EditTournament.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { useNavigate, useParams } from "react-router-dom";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { useAuth } from "../../Context/AuthContext";
import "./EditTournament.css";

const API = process.env.REACT_APP_API;

function EditTournament() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();

  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(false);

  // טען נתוני טורניר קיים
  useEffect(() => {
    const loadTournament = async () => {
      try {
        const { data } = await axios.get(`${API}/api/tournaments/${id}`);
        setForm({
          name: data.name || "",
          showOnWebsite: data.showOnWebsite ?? true,
        });
      } catch (err) {
        console.error("שגיאה בטעינת האירוע:", err);
        toast.error("❌ שגיאה בטעינת האירוע");
      }
    };
    loadTournament();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // שליחה ל־ backend
      await axios.put(`${API}/api/tournaments/${id}`, form,
        {
          headers: {
            "Authorization": `Bearer ${token}`, // 👈 חובה
          },
        });
      toast.success('✅ האירוע עודכן בהצלחה!');
      navigate("/tournaments"); // חזרה לרשימה אחרי שמירה
    } catch (err) {
      console.error("שגיאה בעדכון האירוע:", err);
      toast.error('❌ עדכון האירוע נכשל');
    } finally {
      setLoading(false);
    }
  };

  if (!form) return <p>טוען...</p>;

  return (
    <div className="edit-event-form">
      {/* אייקון הבית בפינה שמאלית עליונה */}
      <div className="home-icon">
        <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")} />
      </div>
      <div className="back-icon">
        <PiKeyReturnFill title="חזרה לעמוד הקודם" size={40} onClick={() => navigate("/tournaments")} />
      </div>
      <h3>✏️ עריכת "{form.name}"</h3>
      <form className="form-grid" onSubmit={handleSubmit}>
        <label>שם הטורניר:</label>
        <input
          type="text"
          name="name"
          value={form.name}
          onChange={handleChange}
          required
        />
        <div className="checkbox-group">
          <label>
            <input
              type="checkbox"
              name="showOnWebsite"
              checked={form.showOnWebsite}
              onChange={handleChange}
            />
            מוצג באתר
          </label>
        </div>
        <div className="buttons">
          <button type="submit" disabled={loading}>
            {loading ? "טוען..." : "עדכון הטורניר"}
          </button>
          <button type="button" onClick={() => navigate("/tournaments")}>⬅️ חזרה</button>
        </div>
      </form>
    </div>
  );
}

export default EditTournament;
